import { useEffect, useMemo, useState } from 'react';

/**
 * Paginação no cliente, para listas que já estão inteiras em memória (os
 * filtros dessas telas são locais). Volta à página 1 quando o conjunto
 * filtrado muda — `chaveDeReinicio` costuma ser a lista de filtros ativos.
 */
export function usePaginacao<T>(itens: T[], chaveDeReinicio: string, tamanhoInicial = 25) {
  const [pagina, setPagina] = useState(1);
  const [tamanhoPagina, setTamanhoPagina] = useState(tamanhoInicial);

  useEffect(() => {
    setPagina(1);
  }, [chaveDeReinicio, tamanhoPagina]);

  const totalPaginas = Math.max(1, Math.ceil(itens.length / tamanhoPagina));
  const paginaAtual = Math.min(pagina, totalPaginas);
  const visiveis = useMemo(
    () => itens.slice((paginaAtual - 1) * tamanhoPagina, paginaAtual * tamanhoPagina),
    [itens, paginaAtual, tamanhoPagina],
  );

  return { visiveis, pagina: paginaAtual, setPagina, tamanhoPagina, setTamanhoPagina, totalPaginas };
}
